export default "__VITE_ASSET__DYnyNwqO__"